import { render, staticRenderFns } from "./visitor-messages.vue?vue&type=template&id=6b521f7b&"
import script from "./visitor-messages.vue?vue&type=script&lang=js&"
export * from "./visitor-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports